import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const BellIcon = ({
  width = "24",
  height = "24",
  color = "#4C545B",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.90039 20.4V18H4.30039V9.6C4.30039 7.94 4.80039 6.4652 5.80039 5.1756C6.80039 3.886 8.10039 3.0408 9.70039 2.64V1.8C9.70039 1.3 9.87559 0.875203 10.226 0.525603C10.5764 0.176003 11.0012 0.000802727 11.5004 2.72727e-06C11.9996 -0.000797273 12.4248 0.174403 12.776 0.525603C13.1272 0.876803 13.302 1.3016 13.3004 1.8V2.64C14.9004 3.04 16.2004 3.8852 17.2004 5.1756C18.2004 6.466 18.7004 7.9408 18.7004 9.6V18H21.1004V20.4H1.90039ZM11.5004 24C10.8404 24 10.2756 23.7652 9.80599 23.2956C9.33639 22.826 9.10119 22.2608 9.10039 21.6H13.9004C13.9004 22.26 13.6656 22.8252 13.196 23.2956C12.7264 23.766 12.1612 24.0008 11.5004 24ZM6.70039 18H16.3004V9.6C16.3004 8.28 15.8304 7.15 14.8904 6.21C13.9504 5.27 12.8204 4.8 11.5004 4.8C10.1804 4.8 9.05039 5.27 8.11039 6.21C7.17039 7.15 6.70039 8.28 6.70039 9.6V18Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
